import { AxiosInstance } from "axios";
import axiosBase from "./base";
import { ConsultationResponse } from "components/AlertsCarousel/AlertsCarouselModel";

class HomeService {
  base: AxiosInstance;

  constructor() {
    this.base = axiosBase.base;
  }
  getNewsArticlesByCategory(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(`news-categories?populate[news_articles_ids][populate]=*`)
        .then(({ data }) => {
          // console.log(data);
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }

  getNewsArticles(is_emergency: boolean): Promise<ConsultationResponse> {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await this.base.get(
          `news-articles?filters[is_emergency][$eq]=${is_emergency}&sort=article_date:desc`
        );
        // console.log(data);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  }

  getIntroduction(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await this.base.get(`intro?[populate]=*`);
        // console.log(data);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  }
  getInfoCarousel(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(`endorsements/?populate=*&sort=priority:asc`)
        .then(({ data }) => {
          // console.log(data);
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
}

const homeService = new HomeService();
export default homeService;
